import React, {useState, useEffect} from "react";
import {
  Main,
  Profile,
  Projects,
  Affiliations,
  Volunteering,
  Papers,
  Contact,
  Navigation,
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';
import { BrowserRouter as Router, Route, Routes, Link, Outlet } from 'react-router-dom';


// Layout that wraps all pages
function Layout({ mode, modeChange }: { mode: 'dark' | 'light'; modeChange: () => void }) {
  return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
      <Navigation parentToChild={{ mode }} modeChange={modeChange} />
      <FadeIn transitionDuration={700}>
        <Outlet />
      </FadeIn>
      <Footer />
    </div>
  );
}


// Homepage content component
function Home({ mode }: { mode: 'dark' | 'light' }) {
  return (
    <>
      <Main mode={mode} />
      <Profile />
      <Projects />
      <Affiliations />
      <Volunteering />
      <Papers />
      <Contact />
    </>
  );
}


function App() {
  const [mode, setMode] = useState<'dark' | 'light'>('dark');

  const handleModeChange = () => {
    setMode(mode === 'dark' ? 'light' : 'dark');
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout mode={mode} modeChange={handleModeChange} />}>
          <Route index element={<Home mode={mode} />} />
        </Route>
      </Routes>
    </Router>
  );
}
  
  export default App;